
const account = {
  state: {
    recharge: false,
    balance: 0, // 账户余额
    user: '',
    menu: '',
    status: '', // 认证状态
    token: ''
  },
  mutations: {
    START_RECHARGE: (state, status) => {
      state.recharge = status
    },
    SET_BALANCE: (state, money) => {
      state.balance = money
    },
    SET_USERNAME: (state, user) => {
      state.user = user
    },
    SET_MENE: (state, menu) => {
      state.menu = menu
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    }
  },
  actions: {
    // 充值弹窗
    Recharge: ({commit}, status) => {
      commit('START_RECHARGE', status)
    },
    // 更新余额
    updateBalance: ({commit}, money) => {
      commit('SET_BALANCE', money)
    },
    updateusername: ({commit}, user) => {
      commit('SET_USERNAME', user)
    },
    updatemenu: ({commit}, menu) => {
      commit('SET_MENE', menu)
    },
    // 更新认证状态
    updateStatus: ({commit}, status) => {
      commit('SET_STATUS', status)
    },
    // 存储鉴权token
    setToken: ({commit}, token) => {
      commit('SET_TOKEN', token)
    }
  }
}
export default account



// WEBPACK FOOTER //
// ./src/store/modules/account.js